module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerWidget('googleAnalytics', {
		configure: function(options) {
			if (!fox.isEmpty(options.gaCodes)) {
				options.gaCodes = this._prepareAccounts(options.gaCodes);
			}

			this.registerOptions('', options);
			this.callParent('configure', arguments);
		},

		init: function() {
			this._includedSnippet = false;
			this._trackersInfo = {}; // Example. If creacted two trackers. {tracker1 : true, tracker2: true}
			this._linkerParam = null; // Contacin cid (unique client if of google analytics) of user
			this._prevTrackedPage = null;

			var gaCodes = null;

			if (!this.checkAccounts()) {
				gaCodes = this.rwom1('@root').getOption('gaCodes') || fox.getEnv('gaCodes');

				if (!fox.isEmpty(gaCodes)) {
					this.setAccounts(gaCodes);
				}
			}

			if (this.checkAccounts()) {
				this.include();
			}

			this.optOut(!!this.getOption('optOut'));
			this.getOption('settings') && this.setSettings(this.getOption('settings'));

			this.callParent('init', arguments);
		},

		/**
		 * Include snippets for properly working of google analytics
		 * @return {void}
		 */
		include: function() {
			if (this._includedSnippet) {
				return;
			}

			_gaScriptLoaded = false;
			_gaLinkerLoaded = false;

			this._includeSnippet();
			this._includedSnippet = true;
		},

		/**
		 * Include snippet for universal ga. Set global flag _gaScriptLoaded after external script loaded.
		 * @return {void}
		 */
		_includeSnippet: function() {
			(function(i,s,o,g,r,a,m){
				i['GoogleAnalyticsObject']=r;
				i[r]=i[r] || function(){
					(i[r].q=i[r].q||[]).push(arguments)
				},
				i[r].l=1*new Date();
				a=s.createElement(o),
				// begin custom code
				a.onload = function() {
					_gaScriptLoaded = true;
				};
				// end custom code
				m=s.getElementsByTagName(o)[0];
				a.async=1;
				a.src=g;
				m.parentNode.insertBefore(a,m)
			})(window,document,'script','//www.google-analytics.com/analytics.js','ga');
		},

		/**
		 * Return accounts of current widget.
		 * @return {array}
		 */
		getAccounts: function() {
			return this.getOption('accounts');
		},

		/**
		 * Set accounts for current widget.
		 * @param {(string|array)} accounts
		 * @return {void}
		 */
		setAccounts: function(accounts) {
			this.setOption('accounts', this._prepareAccounts(accounts));
		},

		/**
		 * Check if accounts is seted.
		 * @return {boolean}
		 */
		checkAccounts: function() {
			return !fox.isEmpty(this.getAccounts());
		},

		/**
		 * Convert raw accounts to array.
		 * @param {(string|array)} accounts
		 * @return {array}
		 */
		_prepareAccounts: function(accounts) {
			if (fox.isString(accounts)) {
				return accounts.split(',');
			}

			if (fox.isArray(accounts)) {
				return accounts;
			}

			throw 'The first argument should be an array or a string, ' + typeOfArg + ' passed';
		},

		/**
		 * Run google analytics query for all accounts.
		 * @param {Object} params Must contain "method" property
		 * @return {void}
		 */
		query: function(params) {
			fox.each(this.getOption('accounts'), function(account, index) {
				this._query(params, account, index);
			}, this);
		},

		/**
		 * Create tracker, if not exists. Tracker is transport of google analytics.
		 * @param {string} account
		 * @param {string} trackerName alias for tracker
		 * @return {void}
		 */
		_createTracker: function(account, trackerName) {
			if (!fox.isEmpty(this._trackersInfo) && !fox.isEmpty(this._trackersInfo[trackerName]) && this._trackersInfo[trackerName] === true) {
				return;
			}

			var cookieDomain = this.getOption('cookieDomain') || 'auto';
			ga('create', account, cookieDomain, trackerName);//, {siteSpeedSampleRate: 10}
			this._trackersInfo[trackerName] = true;
		},

		/**
		 * Generate tracker name for tracker index.
		 * @param {number} index
		 * @return {string}
		 */
		_getTrackerNameById: function(index) {
			return 'tracker' + index;
		},

		/**
		 * Run google analytics query.
		 * @param {Object} params Must contain "method" property
		 * @param {string} account
		 * @param {number} index Index of tracker and account
		 * @return {void}
		 */
		_query: function(params, account, index) {
			var trackerName = this._getTrackerNameById(index);
			this._createTracker(account, trackerName);
			this._setTrackerDimensions(trackerName);

			if (fox.isObject(params.params)) {
				ga(trackerName + '.send', params.method, params.params);
			} else {
				ga.apply(this, [trackerName + '.send', params.method].concat(params.params));
			}
		},

		/**
		 * Set default google dimensions for tracker with name "trackerName"
		 * @param {string} trackerName
		 * return {void}
		 */
		_setTrackerDimensions: function(trackerName) {
			ga(trackerName + '.set', 'dimension1', fox.isEmpty(fox.site.member) ? "0" : "1");
		},

		/**
		 * Track pageview.
		 * @param {string} page Name of tracked page
		 * @return {void}
		 */
		trackPageview: function(page) {
			if (this._prevTrackedPage === page) {
				return;
			}

			this.query({method: 'pageview', params: {page: '/' + page}});
			this._prevTrackedPage = page;
		},

		/**
		 * Track timing
		 * @param {array} params Example: ['api', 'getSocialNetworkList', 100, 'api']
		 * It is meaning [timingCategory], [timingVar], [timingValue], [timingLabel]
		 * @return {void}
		 */
		trackTiming: function(params) {
			this.query({method: 'timing', params: params});
		},

		/**
		 * Track event
		 * @param  {object} params Example: {'eventCategory': 'iPhone banner', 'eventAction': 'closed'}
		 * @return {void}
		 */
		trackEvent: function(params) {
			this.query({method: 'event', params: params});
		},

		/**
		 * Load linker and set linker param (after ga script loaded).  More information
		 * in https://developers.google.com/analytics/devguides/collection/analyticsjs/cross-domain
		 * @return {void}
		 */
		addLinker: function() {
			if (!this.checkAccounts()) {
				return;
			}

			ga('require', 'linker');

			var
				trackerId = 0,
				account = this.getOption('accounts')[trackerId],
				trackerName = this._getTrackerNameById(trackerId)
			;

			this._createTracker(account, trackerName);

			ga(
				fox.bind(
					function() {
						var tracker = ga.getByName(trackerName);
						this._linkerParam  = tracker.get('linkerParam').replace('_ga=', '');
						_gaLinkerLoaded = true;
					},
					this
				)
			);
		},

		/**
		 * Return linker param (contain cid).
		 * @return {string}
		 */
		getLinkerParam: function() {
			return this._linkerParam;
		},

		optOut: function(status) {
			fox.each(this.getOption('accounts'), function(account, index) {
				window['ga-disable-' + account] = status;
			}, this);
		},

		setSettings: function(settings) {
			fox.each(this.getOption('accounts'), function(account, index) {
				ga(account + '.set', settings);
			}, this);
		}

	}, 'Controller');
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-core-resource/lib/widgets/googleanalytics.js
// module id = 199
// module chunks = 0